module.exports = __webpack_public_path__ + "img/title2.75d3f86c.svg";